export default __webpack_public_path__ + "static/media/graph-2-large.0ca872fe.png";